function memo(callback){var result;return function(){if(result===undefined)result=callback();return result;};}export{memo};